module.exports = __webpack_public_path__ + "tables1.webp?38a5ddef56b6ab3daacb27d4e73c0549";